<template>
  <div>
    <b-row>
      <b-col sm="2"><label :for="dbfield+'_input'">{{metadata.label}}:</label></b-col>
      <b-col sm="10">
        <b-form-select :id="dbfield+'_input'" size="sm" v-model="groupvalue[metadata.select_index]" @change="change1">
          <template slot="first">
          <option :value="null" disabled>-- Seleccione una opcion --</option>
          </template>
          <template v-for="(choice, i) in metadata.choices">
          <optgroup v-if="choice.children" :key="'opt_'+i" :label="choice.display_name">
            <option v-for="choicex in choice.children" :value="choicex.value" :key="'opt_'+choicex.value">{{choicex.display_name}}</option>
          </optgroup>
          <option v-else :value="choice.value" :key="'opt_'+choice.value">{{choice.display_name}}</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
    <b-row v-if="sublabel">
      <b-col sm="2"><label :for="subindex+'_input'">{{sublabel}}:</label></b-col>
      <b-col sm="10">
        <b-form-select :id="subindex+'_input'" size="sm" v-model="groupvalue[subindex]" @change="emitx">
          <template slot="first">
          <option :value="null" disabled>-- Seleccione una opcion --</option>
          </template>
          <template v-for="(choice, i) in suboptions">
          <optgroup v-if="choice.children" :key="'opt_'+i" :label="choice.display_name">
            <option v-for="choicex in choice.children" :value="choicex.value" :key="'opt_'+choicex.value">{{choicex.display_name}}</option>
          </optgroup>
          <option v-else :value="choice.value" :key="'opt_'+choice.value">{{choice.display_name}}</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FormComponentBase from './FormComponentBase'

// v-on:input="$emit('input', $event)"

export default {
  name: 'FormComponentChoicexchoice',
  extends: FormComponentBase,
  /* components: {
    FormComponent: () => import('./FormComponent')
  }, */
  data () {
    return {
      groupvalue: {},
      sublabel: null,
      subindex: '',
      suboptions: []
    }
  },
  computed: {
    ...mapState({
      'user': 'user'
    }),
    read_only: function () {
      var readOnly = false
      if (this.metadata.read_only) readOnly = true
      if (this.metadata.edit_roles) {
        if (!this.user) return true
        for (var i in this.metadata.edit_roles) {
          if ((this.user.roles.indexOf('_admin') !== -1) ||
            (this.user.roles.indexOf(this.metadata.edit_roles[i]) !== -1)) {
            return readOnly
          }
        }
        return true
      } else {
        return readOnly
      }
    }
  },
  mounted () {
    if (this.value) {
      this.groupvalue = this.value
    }
  },
  watch: {
    value: function (val) {
      this.$set(this, 'groupvalue', val)
      this.$emit('valuechange', val)
      this.change1(true)
    }
  },
  methods: {
    change1 (newval) {
      var value = this.groupvalue[this.metadata.select_index]
      // console.log('metadata', this.metadata)
      // console.log('value', value)
      for (let i in this.metadata.choices) {
        if (this.metadata.choices[i].value === value) {
          this.$set(this, 'suboptions', this.metadata.choices[i].choices)
          this.$set(this, 'sublabel', this.metadata.choices[i].select_label)
          this.$set(this, 'subindex', this.metadata.choices[i].select_index)
          if (!newval) this.$set(this.groupvalue, this.subindex, null)
        }
      }
      this.emitx()
    },
    emitx () {
      this.$emit('input', this.groupvalue)
    }
  }
}
</script>
